export default "__VITE_ASSET__BycFpqrh__"